<template>
  <div class="market-subject-type" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.5)">
    <div class="title">
      <span>广东省市场主体类型统计</span>
      <span id="btn-link">关联地图展示</span>
    </div>
    <div class="chart-con has-tab">
      <div class="flex-between">
        <ElementSelect
          v-if="!tabIndex"
          :val="year"
          :options="options"
          @val="
            (e) => {
              year = e;
            }
          "
        />
      </div>
      <div class="pie-bg"></div>
      <div class="chart-pie">
        <v-chart ref="pie3D-chart" id="pie3D-chart" class="pie3D-chart" :options="chartOption" />
        <div :class="['chart-legend']">
          <div class="legend-list">
            <div class="legend-item" v-for="(item, i) in chartData" :key="i">
              <div class="name">
                <span class="color" :style="{ 'background-color': colors3D[i] }"></span>
                <el-tooltip effect="dark" placement="top" v-if="item.name && item.name.length > 6">
                  <span>
                    {{ item.name ? item.name : '-' }}
                  </span>
                  <div slot="content">
                    {{ item.name ? item.name : '-' }}
                  </div>
                </el-tooltip>
                <span v-else>
                  {{ item.name ? item.name : '-' }}
                </span>
              </div>
              <span class="num">
                {{ item.value }}
              </span>
              <span class="unit">家</span>
            </div>
          </div>
          <div class="pager-box">
            <i :class="['el-icon-caret-top', { dis: pager.current <= 1 }]" @click="changePage(false)"></i>
            <div>
              {{ pager.current }}
              <span> / {{ pager.total }} </span>
            </div>
            <i :class="['el-icon-caret-bottom', { dis: pager.current >= pager.total }]" @click="changePage(true)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import drawPie3D from '../chartJs/pie3D';
import echarts from 'echarts';
import ElementSelect from '../../../components/element-select';
import cityJson from '../cityJson';

const colors3D = ['#00c9ff', '#0078ff', '#fcf5c2', '#58ecac'];
const colors = [
  '#00c5fa',
  '#0078ff',
  '#fcf5c2',
  '#58ecac',
  '#ff8c60',
  '#a280ff',
  '#ee6566',
  '#fac959',
  '#91cd74',
  '#3aa272',
  '#aae6ff',
];
export default {
  name: 'EconomicProductionPavilion',
  components: { ElementSelect },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      loading: true,
      dialogTitle: '',
      tableData: [],
      pagerTable: {
        currentPage: 1,
        pageSize: 10,
        total: 22,
      },
      apiName: '',
      search: {
        cityName: '',
        year: '',
        enterpriseName: '',
      },
      optionCity: cityJson,
      optionYear: [
        {
          value: 2022,
          label: 2022,
        },
        {
          value: 2021,
          label: 2021,
        },
      ],
      colors,
      colors3D,
      year: null,
      selectList: [
        {
          value: 2020,
          label: '2020',
        },
      ],
      pager: {
        current: 1,
        total: 2,
      },
      legendBox: null,
      chart: null,
      chartOption3D: null,
      chartOption: null,
      chartData: null,
    };
  },
  computed: {
    tableCol() {
      let col = [];
      switch (this.apiName) {
        case 'getSpecialNewEnterpriseList':
        case 'getLitterEnterpriseList':
          col = [
            {
              label: '序号',
              type: 'index',
              maxWidth: 70,
            },
            {
              label: '地市',
              param: 'cityName',
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 320,
              align: 'left',
            },
          ];
          break;
        case 'getMapCityEnList':
          col = [
            {
              label: '排行',
              param: 'ranking',
              maxWidth: 70,
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 300,
              align: 'left',
            },
            {
              label: '所属行业',
              param: 'industry',
              width: 160,
              align: 'left',
            },
            {
              label: '营收（万元）',
              param: 'businessIncome',
              width: 80,
              align: 'left',
            },
          ];
          break;
        default:
          break;
      }
      return col;
    },
  },
  watch: {
    // tabIndex(n) {
    //   if (!n) {
    //     this.chart.off('click');
    //     this.chart.off('mouseover');
    //     this.chart.off('globalout');
    //   }
    //   this.chart = null;
    //   this.chartOption = null;
    //   this.chartOption3D = null;
    //   this.$nextTick(() => {
    //     this.getData();
    //   });
    // },
    year(n) {
      this.$nextTick(() => {
        this.loading = true;
        this.getData();
      });
    },
    chartData(n) {
      this.pager.total = n?.length ? Math.ceil((n?.length * 20) / this.legendBox.clientHeight) : 0;
    },
    'pager.current'(n) {
      if (n) {
        let box = this.legendBox;
        console.log(n, box);
        let y = box.clientHeight * (n - 1);
        box.style.transform = `translateY(-${y > 0 ? y + 15 : y}px)`;
      }
    },
  },
  methods: {
    changePage(next) {
      let { current, total } = this.pager;
      if (next) {
        this.pager.current = current < total ? current + 1 : current;
      } else {
        this.pager.current = current > 1 ? current - 1 : current;
      }
    },
    getData() {
      this.chart = echarts.init(document.getElementById('pie3D-chart'));
      this.$api.market
        .getEnterpriseType({
          year: this.tabIndex ? this.yearP : this.year,
        })
        .then((res) => {
          console.log(res, 779);
          let { data } = res.data;
          let arr = data.map((x) => ({
            name: x.f29034_34aa047006,
            value: x.count,
          }));
          this.chartData = arr;
          while (arr.length > this.colors3D.length) {
            const r = Math.floor(Math.random() * 256);
            const g = Math.floor(Math.random() * 256);
            const b = Math.floor(Math.random() * 256);
            this.colors3D.push('#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1));
          }

          this.$nextTick(() => {
            this.setInterData();
          });
        });
      // .catch((err) => {
      //   this.loading = false;
      // });
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['pie3D-chart'].clear();
        this.chartOption = drawPie3D(this.chartData, 0, this.chart, this.colors3D);
        this.loading = false;
      });
    },
    changeVal(e, type) {
      this.search[type] = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pager.pageSize = e;
      this.getData();
    },
    handleCurrentChange(e) {
      this.pager.currentPage = e;
      this.getData();
    },
  },
  mounted() {
    this.$nextTick(() => {
      let box = $('.legend-list');
      this.legendBox = box[0];
      this.year = this.options.slice(-1)[0].value;
      this.getData();
    });
  },
};
</script>

<style lang="less" scoped>
.market-subject-type {
  .chart-box();
  margin: 0;
  display: inline-block;

  /deep/ .tab-list {
    .tab-item {
      min-width: 60px !important;
    }
  }

  .chart-con {
    overflow: inherit;
  }

  .pie-bg {
    width: 331px;
    height: 198px;
    background: url('~img/home/pie-bg.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: -45px;
    bottom: -5px;
    /*z-index: 2;*/
  }

  .chart-pie {
    display: flex;
  }

  #pie-chart,
  #pie3D-chart {
    width: 245px;
    height: 220px;
    margin-top: -20px;
  }

  .chart-legend {
    width: calc(100% - 245px);
    /*width: 50%;*/
    color: #fff;
    height: 200px;
    padding-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    max-height: 160px;
    overflow: hidden;
    //.show-scroll-bg-trans();

    &.chart3d {
      justify-content: center;
      max-height: 200px;

      .legend-item {
        line-height: 30px;
        margin-bottom: 20px;
      }
    }

    .legend-list {
      height: calc(100% - 20px);
      transition: all 0.3s;
    }

    .pager-box {
      position: absolute;
      right: 0;
      bottom: 10px;
      .flex-center();
      padding-right: 10px;
      font-size: 12px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #87e6ff;
      line-height: 38px;

      div {
        letter-spacing: -2px;
        margin: 0 10px;

        span {
          color: rgba(135, 230, 255, 0.3);
        }
      }

      i {
        margin-top: 2px;
        cursor: pointer;

        &.dis {
          color: rgba(135, 230, 255, 0.3);
          cursor: not-allowed;
        }
      }
    }

    .legend-item {
      .flex-center();
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #dcdcdc;
      /*line-height: 20px;*/
      margin-bottom: 10px;

      &:first-child {
        margin-top: 10px;
      }

      .name {
        width: 100px;
        .flex-center();

        span:last-child {
          width: calc(100% - 21px);
          .ellipsis();
        }
      }
    }

    .color {
      width: 15px;
      height: 11px;
      margin-right: 6px;
    }

    .num {
      width: 80px;
      font-size: 20px;
      font-family: Geometr706 BlkCn BT;
      font-weight: 900;
      color: #fff;
      line-height: 30px;
      margin: 0 5px 0 20px;
      text-align: right;
    }

    .unit {
      font-size: 12px;
    }
  }
}
</style>
